import {Chip, Stack} from "@mui/material";
import React from "react";

interface PresetSelectorProps<T> {
    presets: {label: string, value: T}[]
    onSelect: (preset: T) => void
}


export const PresetSelector = <T,> ({presets, onSelect}: PresetSelectorProps<T>) =>  {

    return <div>
        <header>
            Quick Presets
        </header>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {presets.map((preset, index) => (
                <Chip
                    key={index}
                    label={preset.label}
                    onClick={() => onSelect(preset.value)}
                    clickable
                    variant="outlined"
                    color="primary"
                />
            ))}
        </Stack>
    </div>
}